import React from "react";

interface FooterLinkProps {
  footer: any;
  updateFooterLink: (index: number, key: string, value: string) => void;
  index: number;
  toggleLink: () => void;
  setIndex: (index: number) => void;
  setData: (data: string) => void;
  setDynamicLink: (dynamicLink: string) => void;
  removeLevelHeader: (index: number) => void;
  group_under?: string;
  isSecondLevel?: boolean;
  setFooterIndex: (index: number) => void;
  setSubFooterIndex: (index: number) => void;
  setSubIndex: (index: number) => void;
  addSubFooterLink: (index: number) => void;
  removeSubFooterLink: (index: number, subIndex: number) => void;
  updateSubFooterLink: (
    index: number,
    subIndex: number,
    key: string,
    value: string
  ) => void;
  removeFooterLink: (index: number) => void;
  isEditable?: boolean;
}

const FooterLink: React.FC<FooterLinkProps> = ({
  footer,
  updateFooterLink,
  index,
  toggleLink,
  setIndex,
  setData,
  setDynamicLink,
  setFooterIndex,
  setSubFooterIndex,
  setSubIndex,
  addSubFooterLink,
  removeSubFooterLink,
  updateSubFooterLink,
  removeFooterLink,
  isEditable = true,
}) => {
  return (
    <div className="bg-white border border-black-600 rounded-[5px] px-4 py-4">
      <div className="mb-2">
        <label className="inline-block mb-2 text-base font-medium">Label</label>
        <input
          disabled={!isEditable}
          type="text"
          value={footer.label}
          onChange={(e) => updateFooterLink(index, "label", e.target.value)}
          placeholder="Footer Label"
          className="form-input border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
        />
      </div>
      <div className="mb-2">
        <label className="inline-block mb-2 text-base font-medium">Url</label>

        <div className="flex ">
          <input
            disabled={true}
            type="text"
            value={footer.url}
            // onChange={(e) => updateFooterLink(index, "url", e.target.value)}
            placeholder="Footer URL"
            className="form-input border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
          />
          <div
            onClick={() => {
              toggleLink();
              setFooterIndex(index + 1);
              setSubFooterIndex(undefined);
              setIndex(undefined);
              setSubIndex(undefined);
              setData("urlFooter");
              setDynamicLink("");
            }}
            className="mb-2 ml-2 text-white cursor-pointer btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
          >
            Addlink
          </div>
        </div>
      </div>
      <div className="flex justify-end my-4">
        <button
          onClick={isEditable ? () => addSubFooterLink(index) : null}
          className="text-white btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
        >
          Add Sub-Footer Link
        </button>
      </div>
      {footer?.subfooter_links?.map((sub, subIndex) => (
        <div
          className="bg-white border border-black-600 rounded-[5px] px-4 py-4 mb-3"
          key={`${index}-${subIndex}-${"sub"}`}
        >
          <label className="inline-block mb-2 text-base font-medium">
            Label
          </label>
          <input
            disabled={!isEditable}
            type="text"
            value={sub.label}
            onChange={(e) =>
              updateSubFooterLink(index, subIndex, "label", e.target.value)
            }
            placeholder="Sub-Footer Label"
            className="mb-2 form-input border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
          />
          <label className="inline-block mb-2 text-base font-medium">
            Value
          </label>

          <div className="flex ">
            <input
              disabled={true}
              type="text"
              value={sub.value}
              // onChange={(e) =>
              //   updateSubFooterLink(index, subIndex, "value", e.target.value)
              // }
              placeholder="Sub-Footer Value"
              className="mb-2 form-input border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
            />
            <div
              onClick={() => {
                toggleLink();
                setFooterIndex(index + 1);
                setSubFooterIndex(subIndex + 1);
                setIndex(undefined);
                setData("urlSubFooter");
                setSubIndex(undefined);
                setDynamicLink("");
              }}
              className="mb-2 ml-2 text-white cursor-pointer btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
            >
              Addlink
            </div>
          </div>
          <div className="flex justify-end mt-2">
            <button
              disabled={!isEditable}
              onClick={() => removeSubFooterLink(index, subIndex)}
              className="text-red-500 bg-white btn hover:text-red-500 hover:bg-red-100 focus:text-red-500 focus:bg-red-100 active:text-red-500 active:bg-red-100 dark:bg-zink-600 dark:hover:bg-red-500/10 dark:focus:bg-red-500/10 dark:active:bg-red-500/10"
            >
              Remove Footer
            </button>
          </div>
        </div>
      ))}
      <div className="flex justify-end mt-2">
        <button
          disabled={!isEditable}
          onClick={() => removeFooterLink(index)}
          className="text-red-500 bg-white btn hover:text-red-500 hover:bg-red-100 focus:text-red-500 focus:bg-red-100 active:text-red-500 active:bg-red-100 dark:bg-zink-600 dark:hover:bg-red-500/10 dark:focus:bg-red-500/10 dark:active:bg-red-500/10"
        >
          Remove Footer
        </button>
      </div>
    </div>
  );
};

export default FooterLink;
